module.exports = __webpack_public_path__ + "assets/img/bookmark@1,5x.00900b7b.svg";